// permissions/permissions.js
export const PERMISSIONS = {
  //USER MANAGEMENT PERMISSIONS

  USERS: {
    CREATE: 'user.create',
    UPDATE: 'user.update',
    DELETE: 'user.delete',
    VIEW: 'user.view'
  },

  // LOCATION PERMISSIONS
  LOCATION: {
    CREATE: 'location.create',
    UPDATE: 'location.update',
    DELETE: 'location.delete',
    VIEW_ALL: 'location.view.all',
    VIEW: 'location.view',
    VIEW_LOCATION: 'location.view.location'
  },

  // MENU PERMISSIONS
  // CATEGORY PERMISSIONS
  CATEGORY: {
    CREATE: 'category.create',
    UPDATE: 'category.update',
    DELETE: 'category.delete',
    VIEW: 'category.view'
  },

  // FOOD_ITEMS PERMISSIONS
  FOOD_ITEMS: {
    CREATE: 'food.items.create',
    UPDATE: 'food.items.update',
    DELETE: 'food.items.delete',
    VIEW: 'food.items.view',
    AVAILIBILITY: 'food.items.toggle'
  },

  // ENQUIRIES PERMISSIONS
  ENQUIRIES: {
    CREATE: 'enquiries.create',
    UPDATE: 'enquiries.update',
    DELETE: 'enquiries.delete',
    VIEW: 'enquiries.view'
  },
  // WEBCONTENT PERMISSIONS
  WEBCONTENT: {
    CREATE: 'webcontent.create',
    UPDATE: 'webcontent.update',
    DELETE: 'webcontent.delete',
    VIEW: 'webcontent.view'
  },

  // MENU_MANAGEMENT PERMISSIONS
  MENU_MANAGEMENT: {
    CREATE: 'menu_management.create',
    UPDATE: 'menu_management.update',
    DELETE: 'menu_management.delete',
    VIEW: 'menu_management.view'
  },
  // COUPONS_CODE PERMISSIONS
  COUPONS_CODE: {
    CREATE: 'coupons_code.create',
    UPDATE: 'coupons_code.update',
    DELETE: 'coupons_code.delete',
    VIEW: 'coupons_code.view'
  }
};

// permissions/permissions.js
export const ROLE_PERMISSIONS = {
  SUPER_ADMIN: [
    // USER PERMISSIONS
    PERMISSIONS.USERS.CREATE,
    PERMISSIONS.USERS.UPDATE,
    PERMISSIONS.USERS.DELETE,
    PERMISSIONS.USERS.VIEW,

    // LOCATION PERMISSIONS
    PERMISSIONS.LOCATION.CREATE,
    PERMISSIONS.LOCATION.UPDATE,
    PERMISSIONS.LOCATION.DELETE,
    PERMISSIONS.LOCATION.VIEW_ALL,
    PERMISSIONS.LOCATION.VIEW_LOCATION,

    // CATEGORY PERMISSIONS
    PERMISSIONS.CATEGORY.CREATE,
    PERMISSIONS.CATEGORY.UPDATE,
    PERMISSIONS.CATEGORY.DELETE,
    PERMISSIONS.CATEGORY.VIEW,

    // FOOD_ITEMS PERMISSIONS
    PERMISSIONS.FOOD_ITEMS.CREATE,
    PERMISSIONS.FOOD_ITEMS.UPDATE,
    PERMISSIONS.FOOD_ITEMS.DELETE,
    PERMISSIONS.FOOD_ITEMS.VIEW,
    PERMISSIONS.FOOD_ITEMS.AVAILIBILITY,

    // ENQUIRIES PERMISSIONS
    PERMISSIONS.ENQUIRIES.CREATE,
    PERMISSIONS.ENQUIRIES.UPDATE,
    PERMISSIONS.ENQUIRIES.DELETE,
    PERMISSIONS.ENQUIRIES.VIEW,

    // WEBCONTENT PERMISSIONS
    PERMISSIONS.WEBCONTENT.CREATE,
    PERMISSIONS.WEBCONTENT.UPDATE,
    PERMISSIONS.WEBCONTENT.DELETE,
    PERMISSIONS.WEBCONTENT.VIEW,
    
    //COUPONS_CODE PERMISSIONS
    PERMISSIONS.COUPONS_CODE.CREATE,
    PERMISSIONS.COUPONS_CODE.UPDATE,
    PERMISSIONS.COUPONS_CODE.DELETE,
    PERMISSIONS.COUPONS_CODE.VIEW,
  ],

  ADMIN: [
    // LOCATION PERMISSIONS
    PERMISSIONS.LOCATION.VIEW_LOCATION,
    PERMISSIONS.LOCATION.UPDATE,
    PERMISSIONS.LOCATION.VIEW,

    // FOOD_ITEMS PERMISSIONS
    PERMISSIONS.FOOD_ITEMS.AVAILIBILITY,

    // MENU_MANAGEMENT PERMISSIONS
    PERMISSIONS.MENU_MANAGEMENT.VIEW
  ]
};
